import React, { useState, useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Dropdown } from "react-bootstrap";
import { toast } from "react-hot-toast";

import API from "../../../utils/API";
import PsContext from "../../../context/PsContext";
import ProductLoader from "../Home/productLoader";
import { FeaturedProduct } from "../../elements";
import NO_PRODUCT_IMG from "../../../assets/img/empty.webp";
import FilterSidebar from "../Category/catFilter";

const NewSearch = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(true);
  // const [initialLoader, setInitialLoader] = useState(true);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [filters, setFilters] = useState({});
  const [wishlistItems, setWishlistItems] = useState([]);
  const [sortBy, setSortBy] = useState("Featured");
  const [count, setCount] = useState(0);
  const keyWord = props.match.params.keyword;
  const [showFilter, setShowFilter] = useState(false);

  const [filterCounts, setFilterCounts] = useState({
    color: {},
    size: {},
    offerOnly: 0,
  });

  /* =======================load products======================= */
  /* =======================load products======================= */
  /* =======================load products======================= */

  useEffect(() => {
    loadProducts();
  }, [keyWord]);

  const loadProducts = () => {
    setLoader(true);
    setProducts([]);
    API.get("v1/site/item/search/" + keyWord).then((res) => {
      if (res.data.status === "1") {
        setProducts(res.data.data);
        setAllProducts(res.data.data);
        setCount(res.data.data.length);
      } else {
        setLoader(false);
      }
    });
  };

  /* =======================cart and wishlist function======================= */
  /* =======================cart and wishlist function======================= */
  /* =======================cart and wishlist function======================= */
  const addToCart = (id) => {
    const selectedProduct = products.find((item) => item.id === id);
    if (selectedProduct) {
      selectedProduct.quantity = 1;
      context.addToCart(selectedProduct);
      toast.success("Successfully added to cart!");
    }
  };

  const toggleWishlist = async (itemid) => {
    const customerid =
      context.state.userData.id ||
      JSON.parse(localStorage.getItem("customerData") || "{}").id;

    if (!customerid) {
      toast.error("Please login to manage your wishlist.");
      return;
    }

    const isInWishlist = wishlistItems.includes(itemid);
    const postData = new FormData();
    postData.append("customerid", customerid);
    postData.append("itemid", itemid);

    try {
      if (isInWishlist) {
        const res = await API.post("v1/site/whishlist/delete", postData);
        if (res.data.status === "1") {
          setWishlistItems((prev) => prev.filter((id) => id !== itemid));
          toast.success("Removed from wishlist.");
        } else {
          toast.error(res.data.message || "Error removing from wishlist.");
        }
      } else {
        const res = await API.post("v1/site/whishlist/add", postData);
        if (res.data.status === "1") {
          setWishlistItems((prev) =>
            prev.includes(itemid) ? prev : [...prev, itemid]
          );
          toast.success("Added to wishlist.");
        } else {
          toast.error(res.data.message || "Error adding to wishlist.");
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("Something went wrong.");
    }
  };

  /* =======================filter function======================= */
  /* =======================filter function======================= */
  /* =======================filter function======================= */

  const handleSortChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      sortBy: value,
    }));
  };

  const handleFilterChange = (type, value) => {
    let formattedValue;

    if (type === "minPrice" || type === "maxPrice") {
      formattedValue = parseFloat(value || 0).toFixed(2);
    } else if (type === "color" || type === "size") {
      formattedValue = value;
    } else {
      formattedValue = value;
    }

    // Update filter state
    setFilters((prev) => ({
      ...prev,
      [type]: formattedValue,
    }));
  };

  useEffect(() => {
    let curProducts = [...allProducts];
    const counts = {
      color: {},
      size: {},
      offerOnly: 0,
    };

    allProducts.forEach((item) => {
      if (item.color) {
        item.color.split(",").forEach((color) => {
          const key = color.trim().toLowerCase();
          if (key) counts.color[key] = (counts.color[key] || 0) + 1;
        });
      }
      if (item.i_size) {
        const sizeStr = item.i_size.toUpperCase().replace(/\s/g, "");
        counts.size[sizeStr] = (counts.size[sizeStr] || 0) + 1;
      }

      if (parseFloat(item.salesdiscount) > 0) {
        counts.offerOnly++;
      }
    });

    setFilterCounts(counts);
    // console.log("Filter Counts:", counts);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "" && value.length !== 0) {
        if (key === "minPrice") {
          curProducts = curProducts.filter(
            (item) => parseFloat(item.salesrate) > value
          );
        } else if (key === "maxPrice") {
          curProducts = curProducts.filter(
            (item) => parseFloat(item.salesrate) < value
          );
        } else if (key === "color" && Array.isArray(value)) {
          curProducts = curProducts.filter((item) =>
            value.some(
              (color) =>
                item.color &&
                item.color.toLowerCase().includes(color.toLowerCase())
            )
          );
        } else if (key === "size" && Array.isArray(value)) {
          curProducts = curProducts.filter((item) =>
            value.some((size) => {
              const [minSize, maxSize] = size
                .split("-")
                .map((s) => parseInt(s));
              const sizeValue = item.i_size;

              if (!sizeValue) return false;

              if (sizeValue.includes("TO")) {
                const [rangeStart, rangeEnd] = sizeValue
                  .split("TO")
                  .map((s) => parseInt(s.trim()));
                return rangeStart <= maxSize && rangeEnd >= minSize;
              } else {
                const parsedSize = parseInt(sizeValue.trim());
                return parsedSize >= minSize && parsedSize <= maxSize;
              }
            })
          );
        } else if (key === "offerOnly" && value === true) {
          curProducts = curProducts.filter(
            (item) => parseFloat(item.salesdiscount) > 0
          );
        }
      }
    });

    const isAllEmpty =
      (!filters.minPrice || filters.minPrice === "0.00") &&
      (!filters.maxPrice || filters.maxPrice === "0.00") &&
      (!filters.color || filters.color.length === 0) &&
      (!filters.size || filters.size.length === 0) &&
      !filters.sortBy &&
      !filters.offerOnly;

    if (isAllEmpty) {
      curProducts = [...allProducts];
    }

    if (filters.sortBy) {
      switch (filters.sortBy) {
        case "a-z":
          curProducts.sort((a, b) =>
            (a.itemname || "").localeCompare(b.itemname || "")
          );
          break;
        case "z-a":
          curProducts.sort((a, b) =>
            (b.itemname || "").localeCompare(a.itemname || "")
          );
          break;
        case "price-low-high":
          curProducts.sort(
            (a, b) => parseFloat(a.salesrate) - parseFloat(b.salesrate)
          );
          break;
        case "price-high-low":
          curProducts.sort(
            (a, b) => parseFloat(b.salesrate) - parseFloat(a.salesrate)
          );
          break;
        case "date-old-new":
          curProducts.sort((a, b) => new Date(a.idate) - new Date(b.idate));
          break;
        case "date-new-old":
          curProducts.sort((a, b) => new Date(b.idate) - new Date(a.idate));
          break;
        default:
          break;
      }
    }

    setProducts(curProducts);
  }, [filters, allProducts]);
  return (
    <>
      {" "}
      <div
        className="container-fluid my-3"
        style={{ background: "white", zIndex: "9999" }}
      >
        <div
          className="row tf-lg-hidden justify-content-center"
          style={{
            position: "fixed",
            bottom: "0px",
            background: "white",
            zIndex: "9999",
            width: "100%",
            borderTop: "5px solid #f58b76",
            // paddingTop: "10px",
          }}
        >
          <div className="md-12">
            <h6 className="mt-20 mb-20">
              Showing {count} result{count !== 1 ? "s" : ""} for "{keyWord}"
            </h6>
          </div>
          <div className="col-6">
            <div className="">
              <button
                className="btn btn-outline-dark w-100"
                onClick={() => setShowFilter(true)}
              >
                <i className="fas fa-filter me-2"></i> Filter
              </button>
            </div>
          </div>
          <div className="col-6">
            <div className="tf-control-sorting d-flex justify-content-end mb-3  scroll-3 w-100">
              <Dropdown onSelect={handleSortChange} className="">
                <Dropdown.Toggle
                  className="bg-transparent text-dark hover-0"
                  style={{ border: "1px solid #000" }}
                  id="dropdown-basic"
                >
                  Featured
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item className="text-dark" eventKey="a-z">
                    Alphabetically, A-Z
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="z-a">
                    Alphabetically, Z-A
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-dark"
                    eventKey="price-low-high"
                  >
                    Price, low to high
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-dark"
                    eventKey="price-high-low"
                  >
                    Price, high to low
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="date-old-new">
                    Date, old to new
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="date-new-old">
                    Date, new to old
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid mob-searchs py-3">
        <Row>
          <Col md={3} className="tf-md-hidden">
            <FilterSidebar
              filterCounts={filterCounts}
              onFilterChange={handleFilterChange}
            />
          </Col>

          <Col md={9}>
            <div className="row">
              <div className="col-5 tf-md-hidden">
                <h6 className="mt-20 mb-20">
                  Showing {count} result{count !== 1 ? "s" : ""} for "{keyWord}"
                </h6>
              </div>
              <div className="col-7">
                <div className="tf-control-sorting d-flex justify-content-end mb-3 ">
                  <Dropdown
                    onSelect={handleSortChange}
                    className="tf-md-hidden"
                  >
                    <Dropdown.Toggle
                      className="bg-transparent text-dark"
                      style={{ border: "1px solid #000" }}
                      id="dropdown-basic"
                    >
                      {sortBy}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item className="text-dark" eventKey="a-z">
                        Alphabetically, A-Z
                      </Dropdown.Item>
                      <Dropdown.Item className="text-dark" eventKey="z-a">
                        Alphabetically, Z-A
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-dark"
                        eventKey="price-low-high"
                      >
                        Price, low to high
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-dark"
                        eventKey="price-high-low"
                      >
                        Price, high to low
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-dark"
                        eventKey="date-old-new"
                      >
                        Date, old to new
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-dark"
                        eventKey="date-new-old"
                      >
                        Date, new to old
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* {initialLoader && <ProductLoader size={8} />} */}

            <Row>
              {products.length > 0 ? (
                products.map((item) => (
                  <Col md={3} className="card-product mb-3" key={item.id}>
                    <FeaturedProduct
                      title={item.itemname}
                      image={item.image}
                      image1={item.image1}
                      id={item.id}
                      height="320px"
                      item={item}
                      amount={item.salesrate}
                      addToCart={() => addToCart(item.id)}
                      addToWishlist={() => toggleWishlist(item.id)}
                      isInWishlist={wishlistItems.includes(item.id)}
                    />
                  </Col>
                ))
              ) : (
                <center>
                  <div className>
                    <img
                      style={{ width: "100%", maxWidth: "300px" }}
                      src={NO_PRODUCT_IMG}
                      alt="No products"
                    />
                    <h4 className="mt-5" style={{ fontSize: "20px" }}>
                      The Product Will Update Soon
                    </h4>
                  </div>
                </center>
              )}
            </Row>
          </Col>
        </Row>
      </div>
      <div className={`mobile-drawer ${showFilter ? "open" : ""}`}>
        <div
          className="mobile-drawer-overlay tf-lg-hidden"
          onClick={() => setShowFilter(false)}
        ></div>
        <div className="mobile-drawer-sidebar">
          <div className="text-end p-2 mb-30">
            <button
              className="btn-close bg-transparent5 border-0 w-100"
              onClick={() => setShowFilter(false)}
              style={{
                background: "white",
                position: "absolute",
                right: "-110px",
              }}
            >
              <span className="icon-close"></span>
            </button>
          </div>
          <FilterSidebar
            // slug={slug}
            onFilterChange={handleFilterChange}
            setAllProducts={setAllProducts}
            allProducts={allProducts}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(NewSearch);
